// «داک تکمیل پروژه» (boss's task, 2026-10-24; spec «منطق داک تکمیل پروژه»; docs/tasks/24-project-setup-dock.md):
// the six structural parts of a project, each ticked only from saved data (the project as the server returned it).

export const SETUP_STEPS = ["owner", "deadline", "goal", "milestone", "members", "tasks"];
export const CLOSED_PROJECT_STATES = ["achieved", "canceled", "archived"];
export const TASKS_NEEDED = 3;

const keyOf = (item) => item?.documentId || item?.id;
const activeList = (list) => (Array.isArray(list) ? list : []).filter((item) => item && !item.archivedAt);

// tasks tied to the project's milestones (the spec counts tasks «متصل به خروجی‌های این پروژه»), each once
export function milestoneTaskCount(project) {
    const seen = new Set();
    activeList(project?.deliverables).forEach((milestone) => {
        activeList(milestone.tasks).forEach((task) => seen.add(String(keyOf(task))));
    });
    return seen.size;
}

export function setupState(project) {
    const ownerKey = keyOf(project?.owner);
    const otherMembers = (project?.members || []).filter((member) => member && keyOf(member) !== ownerKey);
    const milestones = activeList(project?.deliverables);
    const goals = activeList(project?.goals);
    const taskCount = milestoneTaskCount(project);
    const done = {
        owner: Boolean(ownerKey),
        deadline: Boolean(project?.dueDate),
        goal: goals.length > 0,
        milestone: milestones.length > 0,
        members: otherMembers.length > 0,
        tasks: taskCount >= TASKS_NEEDED,
    };
    const completed = SETUP_STEPS.filter((step) => done[step]).length;
    return {
        done,
        completed,
        total: SETUP_STEPS.length,
        percent: Math.round((completed / SETUP_STEPS.length) * 100),
        allDone: completed === SETUP_STEPS.length,
        counts: {goals: goals.length, milestones: milestones.length, members: otherMembers.length, tasks: taskCount},
    };
}

// the one warning above the dock, most important first (spec §4)
export function setupWarning(state) {
    if (!state.done.goal) return "goal";
    if (!state.done.milestone) return "milestone";
    if (!state.done.tasks) return "tasks";
    return null;
}

export const isClosedProject = (project) => Boolean(project?.archivedAt) || CLOSED_PROJECT_STATES.includes(project?.projectStatus);
